'use client';

import { c as _c } from "react/compiler-runtime";
import type { ContentfulEnvironmentOverride, SitePreviewData } from '../types';
import { getENV } from '../utils';
import { useCacheKey } from './useCacheKey';
const CONTENTFUL_ENVIRONMENT_OVERRIDES: ContentfulEnvironmentOverride[] = ['stage'];
function parsePreviewCookie(value: string): SitePreviewData | null {
  try {
    const parsed: unknown = JSON.parse(value);
    if (typeof parsed !== 'object' || parsed === null) {
      return null;
    }
    const obj = parsed as Record<string, unknown>;
    const result: SitePreviewData = {};
    if (typeof obj.previewDate === 'string') {
      result.previewDate = obj.previewDate;
    }
    if (getENV('NEXT_PUBLIC_APP_ENV') === 'stage' && CONTENTFUL_ENVIRONMENT_OVERRIDES.includes(obj.contentfulEnvironment as ContentfulEnvironmentOverride)) {
      result.contentfulEnvironment = obj.contentfulEnvironment as ContentfulEnvironmentOverride;
    }
    if (typeof obj.contentfulPreviewMode === 'boolean') {
      result.contentfulPreviewMode = obj.contentfulPreviewMode;
    }
    return result;
  } catch {
    return null;
  }
}
export function useSitePreviewData() {
  const $ = _c(3);
  const {
    cookies
  } = useCacheKey();
  if (!getENV("NEXT_PUBLIC_SITE_PREVIEW")) {
    return null;
  }
  let t0;
  let t1;
  if ($[0] !== cookies) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const raw = cookies.get("x-petm-preview");
      if (!raw) {
        t1 = null;
        break bb0;
      }
      t0 = parsePreviewCookie(raw);
    }
    $[0] = cookies;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  return t0;
}